<template>
  <transition name="fade">
    <div v-if="isVisible" class="absolute inset-x-0 top-0 z-30 text-center">
      <div
        v-for="item in dataNotification"
        :key="item.id"
        :class="[bgColor, fontColor]"
        class="h-10 text-white flex justify-center items-center py-2 opacity-90"
      >
        {{ item.message }}
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";

export default {
  name: "SplashScreen",

  data() {
    return {
      isVisible: false,
      bgColor: "bg-danger",
      fontColor: "text-white",
      dataNotification: [],
      responseTimer: null
    };
  },
  mounted() {
    this.getAlarmNotification();
  },

  beforeDestroy() {
    clearTimeout(this.responseTimer);
  },

  methods: {
    async getAlarmNotification() {
      if (import.meta.env.VITE_APP_HEALTHCHECK_URL) {
        try {
          const response = await axios.get(import.meta.env.VITE_APP_HEALTHCHECK_URL);
          if (response.data === null) {
            this.isVisible = false;
          } else {
            this.isVisible = true;
            this.dataNotification = [response.data];

            if (!response.data.message || response.data.message === "") {
              this.bgColor = "bg-danger";
              response.data.message = this.$t("Errors.SplashNotificationError");
            }

            if (response.data.severity === "Yellow") {
              this.bgColor = "bg-warning";
              this.fontColor = "text-black";
              response.data.message = this.$t("Errors.SplashNotificationMessage");
            }
          }
        } catch {
          /* empty */
        } finally {
          this.responseTimer = setTimeout(this.getAlarmNotification, 30000);
        }
      }
    }
  }
};
</script>
